import React from 'react';
import Postnav from '../../components/Postnav/Postnav';
import BigBanners from '../../components/banners/bigbanners/BigBanners';
import ProductosDestacados from '../../components/productos-destacados/ProductosDestacados';
import TiendasDestacadas from '../../components/tiendas-destacadas/TiendasDestacadas';
import MdcOffer from '../../components/banners/longbanners/MdcOffer';
import Footer from '../../components/Footer/Footer';
import './inicio.css';

const Icon = ({ path }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <path d={path} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ICONS = {
  leaf: 'M4 20c0-8 5-13 15-14 1 10-4 15-12 15H4Zm2.5-2.5C10 12.5 13 10.5 16 9.5',
  store: 'M3 9l1.5-4.5h15L21 9M3 9h18M3 9v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9M9.5 20v-6h5v6',
  pot: 'M5 10h14l-1.4 9.2a2 2 0 0 1-2 1.8H8.4a2 2 0 0 1-2-1.8L5 10ZM12 10V6.4M12 6.4c0-1.7 1.4-3 3.1-3 0 1.7-1.4 3-3.1 3ZM12 6.4c0-1.7-1.4-3-3.1-3 0 1.7 1.4 3 3.1 3Z',
  burst: 'M12 3.5v4.2M12 16.3v4.2M20.5 12h-4.2M7.7 12H3.5M18 6l-3 3M9 15l-3 3M18 18l-3-3M9 9 6 6',
};

const categorias = [
  {
    icon: ICONS.leaf,
    title: 'CBD y bienestar',
    description: 'Aceites, cremas y tinturas de marcas que trabajan con análisis de laboratorio.',
    href: '/productos',
  },
  {
    icon: ICONS.store,
    title: 'Tiendas del ambiente',
    description: 'Growshops, marcas chicas y productores que venden directo, sin intermediarios.',
    href: '/productos',
  },
  {
    icon: ICONS.pot,
    title: 'Cultivo y accesorios',
    description: 'Sustratos, iluminación, herramientas y todo lo que le falta a tu carpa.',
    href: '/productos',
  },
  {
    icon: ICONS.burst,
    title: 'Recién publicado',
    description: 'Lo último que subieron las tiendas, actualizado a lo largo del día.',
    href: '/productos',
  },
];

const atajos = [
  { label: 'Envíos a todo el país', href: '/productos' },
  { label: 'Tiendas destacadas', href: '/productos' },
  { label: 'Aceites de CBD', href: '/productos' },
  { label: 'Accesorios', href: '/productos' },
  { label: 'Marcas nuevas', href: '/productos' },
  { label: 'Ofertas', href: '/productos' },
];

function Inicio() {
  return (
    <div className="inicio-page">
      <div className="outheader">
        <div className="background inicio-background">
          <div className="background-center-color inicio-shell">
            <div className="postnav-container inicio-postnav-container">
              <Postnav />
            </div>

            <div className="inicio-hero-block">
              <div className="bigbanner">
                <div className="indexcss-margin1">
                  <BigBanners />
                </div>
              </div>
            </div>

            <section className="inicio-quick-access">
              <div className="inicio-section-heading">
                <span className="inicio-eyebrow">Marketplace</span>
                <h2>Buscá por categoría, por tienda o por lo que necesites.</h2>
              </div>
              <div className="inicio-quick-grid">
                {categorias.map((item) => (
                  <a key={item.title} href={item.href} className="inicio-quick-card">
                    <span className="inicio-quick-accent">
                      <Icon path={item.icon} />
                    </span>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <span className="inicio-quick-cta">Ver productos</span>
                  </a>
                ))}
              </div>
            </section>

            <nav className="inicio-market-shortcuts" aria-label="Atajos del marketplace">
              {atajos.map((item) => (
                <a key={item.label} href={item.href} className="inicio-market-shortcut">
                  <strong>{item.label}</strong>
                </a>
              ))}
            </nav>

            <div className="indexcss-margin1">
              <div className="center-content-backgroundcolor inicio-products-surface">
                <div className="center-content-1300">
                  <ProductosDestacados
                    eyebrow="Selección"
                    title="Lo que más se está buscando."
                    description="Los productos con más movimiento en el marketplace."
                    limit={8}
                  />
                </div>
              </div>
            </div>

            <section className="inicio-middle-promo">
              <div className="inicio-middle-promo-card inicio-middle-promo-left">
                <span className="inicio-promo-kicker">Vendé con nosotros</span>
                <h3>Abrí tu tienda y mostrale tu catálogo a todo el país.</h3>
                <p>
                  Publicás tus productos, definís cómo enviás y hablás directo con el comprador.
                </p>
                <a href="/cuenta#PublicaConNosotros">Abrir mi tienda</a>
              </div>
              <div className="inicio-middle-promo-card inicio-middle-promo-right">
                <span className="inicio-promo-kicker">Cómo funciona</span>
                <h3>Le comprás a la tienda, no a un intermediario.</h3>
                <p>
                  Elegís el producto, coordinás con quien lo vende y listo. Cannubis es el lugar
                  donde se encuentran.
                </p>
              </div>
            </section>

            <div className="indexcss-margin1">
              <div className="center-content-backgroundcolor inicio-products-surface inicio-products-surface-secondary">
                <div className="center-content-1300">
                  <ProductosDestacados
                    eyebrow="Seguí mirando"
                    title="Más productos para descubrir."
                    description="Novedades de las tiendas que se sumaron último."
                    limit={8}
                  />
                </div>
              </div>
            </div>

            <div className="indexcss-margin1">
              <div className="inicio-offer-strip">
                <MdcOffer type="Offer" />
              </div>
            </div>

            <div className="indexcss-margin1">
              <div className="center-content-backgroundcolor inicio-stores-surface">
                <div className="center-content-1300">
                  <TiendasDestacadas variant="featured" />
                </div>
              </div>
            </div>

            <div className="indexcss-margin1 inicio-mdc-strip">
              <MdcOffer type="Mdc" />
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inicio;
